import { render, staticRenderFns } from "./TablaSeriesTodos.vue?vue&type=template&id=46bef982&"
import script from "./TablaSeriesTodos.vue?vue&type=script&lang=ts&"
export * from "./TablaSeriesTodos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('46bef982', component.options)
    } else {
      api.reload('46bef982', component.options)
    }
    module.hot.accept("./TablaSeriesTodos.vue?vue&type=template&id=46bef982&", function () {
      api.rerender('46bef982', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/OrdenesSerTec/TablaSeriesTodos.vue"
export default component.exports